<template lang="pug">
    v-container.mx-auto(v-if="!isLoading")
        .text-subtitle-2.mb-5.text-center(v-if="validIntegrationAppointments")
            | Upcoming Appointments

        DetailsCard(
            v-if="validIntegrationAppointments"
            v-for='(integrationAppointment, idx) in integrationAppointments'
            :key="idx"
            :integration-appointment="integrationAppointment"
            :current-campaign-customer="currentCampaignCustomer"
            :current-integration="currentIntegration"
            :display-reschedule-view="displayRescheduleView"
            :display-details-view="displayDetailsView"
            :handle-cancel-integration-appointment="handleCancelIntegrationAppointment"
            icon="mdi-calendar-clock-outline"
            :set-scoped-appointment="setScopedAppointment"
            :set-integration-appointment-details="setIntegrationAppointmentDetails"
            :set-integration-error="setIntegrationError"
            :show-snackbar="showSnackbar"
            :advisor-map="advisorMap"
            :transport-map="transportMap"
            :shop-map="shopMap"
            :titleize="titleize"
        )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import DetailsCard from '@/components/communication_center/shared/tabs/integration/details_card.vue';

    export default Vue.extend({
        data() {
            return {}
        },
        methods: {

        },
        computed: {
            validIntegrationAppointments() {
                return this.integrationAppointments?.length > 0;
            },
        },
        components: {
            DetailsCard,
        },
        props: {
            currentCampaignCustomer: Object,
            currentIntegration: String,
            displayRescheduleView: Function,
            displayDetailsView: Function,
            getIntegrationAppointments: Function,
            handleCancelIntegrationAppointment: Function,
            isLoading: Boolean,
            setScopedAppointment: Function,
            setIntegrationError: Function,
            showSnackbar: Function,
            setIntegrationAppointmentDetails: Function,
            integrationAppointments: Array,
            titleize: Function,
            advisorMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            },
            transportMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            },
            shopMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            }
        },
        created() {

        },
        destroyed() {
        }
    });
</script>

<style lang="scss" scoped>
</style>
